<div class="atn-mapping-tab">
  <atn-ds-section name="General">
    <div class="atn-mapping-tab__general-section">
      <div class="atn-mapping-tab__adjustment-label-title">
        Adjustment label
      </div>
      <div class="atn-mapping-tab__adjustment-label-value">
        @if (adjustmentLabelSg(); as adjustmentLabel) {
          {{ adjustmentLabel }}
        } @else {
          <i>None</i>
        }
      </div>
    </div>
  </atn-ds-section>
  <atn-ds-section
    name="Mapping"
    class="atn-mapping-tab__mapping-section"
  >
    <atn-ds-table [config]="tableConfig" />
  </atn-ds-section>
</div>
